import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Row, Col, FormGroup, InputGroup, FormControl, Button, Alert as BSAlert } from "react-bootstrap";
import { CSVLink } from "react-csv";
import Alert from "react-s-alert";
import axios from 'axios';
import { CSVReader } from "react-papaparse";
import { ApolloProvider, ApolloClient, InMemoryCache, HttpLink, split, useSubscription, gql, useMutation, useApolloClient } from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { confirmAlert } from 'react-confirm-alert';
import * as EmailValidator from 'email-validator';
import { difference } from 'underscore'
import { useQuery as useRestQuery } from 'react-query'

import ParticipantsTable from './participants-list-table-new'
import ParticipantsListForm from './participants-list-form';
import Pageloading, { ContentLoading } from '../../../components/Loading';
// import { cleanObjectAndReturn } from "../../../helpers/cleanObject"
import { DeleteIcon, SentEmailIcon } from '../../../components/svgs';
import EmailParticipantsModal from './email-participants-modal';
import 'react-confirm-alert/src/react-confirm-alert.css';

export const putEventEngagementUserImport = (props) => {
  const { event_id, users } = props;
  return axios({
    url: `${process.env.REACT_APP_API_HOST}/event-engagement/${event_id}/users-import`,
    method: 'PUT',
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    data: { users },
  }).then(response => response.data.data

  )
}

// console.log("inside  participant list  ",users,data)
const ParticipantsListModal = ({ intl, showParticipantsModal, handleParticipantsModal, event }) => {
  const [client, setClient] = useState(null);
  const configureApolloClient = useCallback((_id) => {
    const getAuthToken = async () => {
      try {
        const authHeader = `Bearer ${localStorage.getItem("token")}`;
        const httpLink = new HttpLink({
          uri: `${process.env.NODE_ENV === 'development' ? 'http' : 'https'}://${process.env.REACT_APP_ENGAGEMENT_ENDPOINT}`,
          headers: {
            Authorization: authHeader
          },
        });

        const wsLink = new WebSocketLink({
          uri: `${process.env.NODE_ENV === 'development' ? 'ws' : 'wss'}://${process.env.REACT_APP_ENGAGEMENT_ENDPOINT}`,
          options: {
            reconnect: true,
            connectionParams: () => ({
              headers: {
                Authorization: authHeader,
              }
            }),
          },
        });

        const splitLink = split(
          ({ query }) => {
            const definition = getMainDefinition(query);
            return (
              definition.kind === 'OperationDefinition' &&
              definition.operation === 'subscription'
            );
          },
          wsLink,
          httpLink,
        );

        const c = new ApolloClient({
          link: splitLink,
          cache: new InMemoryCache({
            // typePolicies: {
            //   question: {
            //     merge: true,
            //   }
            // }
          }),
        });
        setClient(c);
      } catch (e) {
        // no user
        alert('There was an error while fetching the participants.')
        // setClient(new ApolloClient({
        //   uri: `${process.env.NODE_ENV === 'development' ? 'http' : 'https' }://${process.env.REACT_APP_ENGAGEMENT_ENDPOINT}`,
        //   cache: new InMemoryCache(),      
        // }));
      }
    }
    getAuthToken();

    return () => {
      setClient(null);
    }
  }, []);

  useEffect(() => {
    if (!event._id) {
      return;
    }
    configureApolloClient(event._id);
  }, [event._id, configureApolloClient]);

  if (!showParticipantsModal) {
    return <React.Fragment></React.Fragment>;
  }

  if (!client) {
    return <i>Loading</i>
  }

  return (
    <ApolloProvider client={client}>
      <Modal className="participants-modal" show={showParticipantsModal} onHide={handleParticipantsModal} size="xl">
        {event._id && <CustomModalBody intl={intl} event={event} />}
      </Modal>
    </ApolloProvider>
  )
}

const CustomModalBody = ({ intl, event }) => {
  const [participantsSearch, setParticipantsSearch] = React.useState('');
  const [addEditListModal, setAddEditListModal] = React.useState(null);
  const [emailModal, setEmailModal] = React.useState(false);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const apolloClient = useApolloClient();
  const defaultImportStatus = {
    show: false,
    emailIssues: [],
    usersToBeCreated: [],
    usersToBeUpdated: [],
  };
  const [importStatus, setImportStatus] = useState(defaultImportStatus);

  // const [putEventEngagementUserImportMutation] = useMutation(putEventEngagementUserImport, {
  //   onMutate: () => {
  //     Alert.warning("updating");
  //   },
  //   onSuccess: (updatedUsers) => {
  //     // console.log('debug: putEventEngagementUserImport: ', updatedUsers);
  //     queryCache.setQueryData(['event-engagement-users', event._id], updatedUsers);
  //     Alert.success(intl.formatMessage({id: 'event-engagement-users.import-success'}));
  //   },
  //   onError: (err) => {
  //     Alert.error(intl.formatMessage({ id: err.response.data.message }))
  //   }
  // })

  const buttonRef = React.createRef();

  const handleOpenDialog = (e) => {
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };

  const { data, loading, error } = useSubscription(gql`
    subscription ($event_id: String!) {
      user(where: {
        source: {
          _in: ["account", "manual", "list", "speaker","website"]
        },
        event_id: {
          _eq: $event_id
        }
      }) {
        id
        name
        source
        photo
        email
        password
        is_moderator
        is_speaker
        is_association
        speaker_id
        disabled
      }
    }
  `, {
    variables: {
      event_id: event._id
    },
    skip: !event._id,
  })

  const [deleteParticipantsMutation, { loading: deleteParticipantsMutationLoading }] = useMutation(gql`
    mutation ($ids: [uuid!]) {
      delete_user(where: {
        id: {
          _in: $ids
        }
      }) {
        affected_rows
      }
    }
  `);

  const confirmDeleteParticipants = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='confirm-delete-modal'>
            <h3>{intl.formatMessage({ id: 'delete.participants' })}</h3>
            <ol>
              {
                selectedParticipants.map(p => <li key={p.id}>{p.name} {p.email ? `(${p.email})` : ''}</li>)
              }
            </ol>
            <Button
              variant='primary'
              disabled={deleteParticipantsMutationLoading}
              onClick={async () => {
                try {
                  await deleteParticipantsMutation({
                    variables: {
                      ids: selectedParticipants.map(p => p.id)
                    },
                  })
                  onClose();
                } catch (e) {
                  // TODO
                  alert("There was an error while deleting the participants.");
                }
              }}
            >
              {intl.formatMessage({ id: 'yes' })}
            </Button>
            <Button variant='default' disabled={deleteParticipantsMutationLoading} onClick={onClose}>
              {intl.formatMessage({ id: 'no' })}
            </Button>
          </div>
        );
      }
    });
  }

  if (error) {
    return <Modal.Body>
      There was an error:
      <pre>{JSON.stringify({ error }, null, 2)}</pre>
    </Modal.Body>
  }

  return <React.Fragment>
    <Modal.Header closeButton>
      <Row className="align-items-center">
        <Col md={8}>
          <div className="title-with-actions d-flex align-items-center">
            <h5>{intl.formatMessage({ id: 'participants.list' })}</h5>
            <Button onClick={() => setAddEditListModal(true)} variant="primary"><img src="/icons/plus-icon.svg" alt="add" /></Button>
            <Button
              title={intl.formatMessage({ id: 'tooltip.delete-attendees' })}
              disabled={
                (selectedParticipants.find(s => s.cant_delete)) ||
                (selectedParticipants.length === 0)
              }
              onClick={confirmDeleteParticipants}
              variant="link">
              <DeleteIcon />
            </Button>
            <Button title={intl.formatMessage({ id: 'tooltip.email-attendees' })} disabled={selectedParticipants.length === 0} onClick={() => setEmailModal(true)} className="email-btn" variant="link"><SentEmailIcon /></Button>
          </div>
        </Col>
        <Col md={4}>
          <div className="right-bar">
            <FormGroup className="m-b-0">
              <InputGroup onChange={(e) => {
                setParticipantsSearch(e.target.value)
              }}>
                <FormControl type="text" />
                <InputGroup.Append>
                  <Button>
                    <img src="/icons/search.png" alt="plus" />
                  </Button>
                </InputGroup.Append>
              </InputGroup>
            </FormGroup>
            {
              (loading) ?
                <ContentLoading />
                :
                <CSVLink
                  data={data.user.map((row) => {
                    return {
                      ...row,
                      is_moderator: row.is_moderator ? 1 : 0,
                      is_speaker: row.is_speaker ? 1 : 0,
                      is_association: row.is_association ? 1 : 0,
                      disabled: row.disabled ? 1 : 0,
                    }
                  })}
                  headers={[
                    { label: "Name", key: "name" },
                    { label: "Email", key: "email" },
                    { label: "Password", key: "password" },
                    { label: "Is Moderator", key: "is_moderator" },
                    { label: "Is Speaker", key: "is_speaker" },
                    { label: "Is Association", key: "is_association" },
                    { label: "Disabled", key: "disabled" },
                  ]}
                  separator={";"}
                  filename={`${event.name} - participant-list.csv`}
                >
                  <Button className="curved-common-button" variant="primary">
                    <img src="/icons/download.png" alt="" />
                  </Button>
                </CSVLink>
            }
            <div className="csv-reader-container">
              <CSVReader
                ref={buttonRef}
                onDrop={async (data) => {
                  setImportStatus(defaultImportStatus);
                  if (data.length === 0) {
                    Alert.error("No rows were found.");
                    return;
                  }

                  let headers = null;
                  const row0 = data[0];

                  if (row0.data.indexOf("Email") > -1) {
                    // if header is present
                    headers = data[0];
                    data = data.slice(1)
                  }

                  const invalidPassword = data.findIndex(d => {
                    const p = d.data[headers ? headers.data.indexOf('Password') : 1];
                    return p ? p.trim().length < 6 : false;
                  })
                  if (invalidPassword !== -1) {
                    Alert.error(`Password in row ${invalidPassword + 1} is less than 6 characters.`);
                    return;
                  }

                  const invalidEmail = data.findIndex(d => !EmailValidator.validate(d.data[headers ? headers.data.indexOf('Email') : 1].trim()))
                  if (invalidEmail !== -1) {
                    Alert.error(`Email in row ${invalidEmail + 1} is invalid.`);
                    return;
                  }

                  try {
                    const users = data.map(d => ({
                      name: d.data[headers ? headers.data.indexOf('Name') : 0].trim(),
                      email: d.data[headers ? headers.data.indexOf('Email') : 1].trim(),
                      password: d.data[headers ? headers.data.indexOf('Password') : 2],
                      is_moderator: d.data[headers ? headers.data.indexOf('Is Moderator') : 3] ? true : false,
                      disabled: d.data[headers ? headers.data.indexOf('Disabled') : 4] ? true : false,
                    })).filter(d => Object.keys(d).length !== 0)

                    if (users.length === 0) {
                      Alert.error("No rows were found.");
                      return;
                    }

                    const emailCheck = await apolloClient.query({
                      query: gql`
                        query (
                          $emails: [String!]
                          $event_id: String!
                        ) {
                          emails: user(where: {
                            email: {
                              _in: $emails
                            }
                            event_id: {
                              _eq: $event_id
                            }
                          }) {
                            id
                            email
                            password
                          }
                        }
                      `,
                      variables: {
                        emails: users.map(u => u.email),
                        event_id: event._id
                      },
                      fetchPolicy: "network-only"
                    })

                    // emails of exiting list and manual users
                    const emailUpdates = emailCheck.data.emails.map(e => e.email);

                    // users to be created
                    const usersToBeCreated = users
                      .filter(u => emailUpdates.indexOf(u.email) === -1);

                    // users to be updated
                    const usersToBeUpdated = users
                      .filter(u => emailUpdates.indexOf(u.email) > -1);

                    // const invalidPassword = usersToBeCreated.findIndex(d => {
                    //   return d.password ? d.password.trim().length < 6 : true;
                    // })
                    // if(invalidPassword !== -1) {
                    //   Alert.error(`Password in row ${invalidPassword + 1} is less than 6 characters.`);
                    //   return;
                    // }

                    setImportStatus(status => ({
                      ...status,
                      show: true,
                      usersToBeCreated,
                      usersToBeUpdated
                    }))

                    if (usersToBeCreated.length === 0 && usersToBeUpdated.length === 0) {
                      Alert.success('Import skipped');
                      return;
                    }

                    const importResponse = await apolloClient.mutate({
                      mutation: gql`
                        mutation (
                          $objects: [user_insert_input!]!
                        ) {
                          insert_user(
                            objects: $objects
                            on_conflict: {
                              constraint: user_pkey
                              update_columns: [
                                name
                                email
                                password
                                is_moderator
                                disabled
                              ]
                            }
                          ) {
                            affected_rows
                          }
                        }
                      `,
                      variables: {
                        objects: [
                          ...usersToBeCreated
                            .map(u => ({
                              ...u,
                              source: 'list',
                              event_id: event._id
                            })),
                          ...usersToBeUpdated
                            .map(u => {
                              const existingUser = emailCheck.data.emails.find(e => e.email === u.email);
                              return {
                                ...u,
                                id: existingUser.id,
                                password: u.password ? u.password : existingUser.password,
                                source: 'list',
                                event_id: event._id
                              }
                            })
                        ]
                      }
                    })

                    console.log('importResponse: ', importResponse);
                    Alert.success('Import complete');
                  } catch (e) {
                    console.log(e);
                    alert(e);
                  }
                }
                }
                onError={(err) => {
                  console.log("onError: ", err);
                }}
                style={{
                  dropArea: {
                    padding: 0, border: 0
                  },
                  fileSizeInfo: {
                    display: 'none'
                  },
                  fileNameInfo: {
                    color: 'red',
                    borderRadius: 3,
                    fontSize: 14,
                    lineHeight: 1,
                    padding: '0 0.4em',
                  }
                }}
                config={{
                  dynamicTyping: true,
                  skipEmptyLines: 'greedy',
                }}
              >
                {({ file }) => (
                  <aside className="upload-csv-container">
                    <Button
                      className="curved-common-button"
                      variant="primary"
                      onClick={(e) => handleOpenDialog(e)}
                    >
                      <img src="/icons/upload.png" alt="" />
                    </Button>
                    <div className="fileName">
                      {file && file.name}
                    </div>
                  </aside>
                )}
              </CSVReader>
            </div>
          </div>
        </Col>
      </Row>
    </Modal.Header>
    <Modal.Body>
      {
        importStatus.show &&
        <BSAlert variant="info" onClose={() => setImportStatus(defaultImportStatus)} dismissible>
          <BSAlert.Heading>Importing status</BSAlert.Heading>
          {
            importStatus.emailIssues.length > 0 &&
            <>
              <hr />
              <p>
                <b>The following records had an email conflict.</b>
                <ul>{importStatus.emailIssues.map((e) => <li key={e}>{e}</li>)}</ul>
              </p>
            </>
          }
          {
            importStatus.usersToBeCreated.length > 0 &&
            <>
              <hr />
              <p>
                <b>The following records are being created.</b>
                <ul>{importStatus.usersToBeCreated.map((e) => <li key={e.login}>{e.login} ({e.email})</li>)}</ul>
              </p>
            </>
          }
          {
            importStatus.usersToBeUpdated.length > 0 &&
            <>
              <hr />
              <p>
                <b>The following records records are being updated.</b>
                <ul>{importStatus.usersToBeUpdated.map((e) => <li key={e.login}>{e.login} ({e.email})</li>)}</ul>
              </p>
            </>
          }

          <p className="mb-0"></p>
        </BSAlert>
      }
      {
        loading ?
          <Pageloading />
          : <>
            <ParticipantsTable
              participantsSearch={participantsSearch}
              event={{ _id: event._id, displayMode: event.displayMode, loginMode: event.loginMode }}
              intl={intl}
              data={data.user}
              editUser={setAddEditListModal}
              setSelectedParticipants={setSelectedParticipants}
            />
          </>
      }
    </Modal.Body>
    <div className="participants-legend">
      {/* <div className="details">
        <img src="/icons/user-unlocked.svg" alt="unlocked" />
        <span> = {intl.formatMessage({ id: 'input.audience.unblocked' })}</span>
      </div>
      <div className="details">
        <img src="/icons/user-locked.svg" alt="locked" />
        <span> = {intl.formatMessage({ id: 'input.audience.blocked' })}</span>
      </div>
      <div className="details">
        <img src="/icons/user-normal.svg" alt="user" />
        <span> = {intl.formatMessage({ id: 'p.user' })}</span>
      </div>
      <div className="details">
        <img src="/icons/user-moderator.svg" alt="moderator" />
        <span> = {intl.formatMessage({ id: 'p.moderator' })}</span>
      </div> */}
      {/* <div className="details">
        <img src="/icons/p-edit.svg" alt="edit" />
        <span> = {intl.formatMessage({id: 'edit'})}</span>
      </div> */}
      <ParticipantsListForm
        intl={intl}
        show={addEditListModal}
        onHide={() => setAddEditListModal(false)}
        event_id={event._id}
      />
      {/* <pre>{JSON.stringify(selectedParticipants, null, 2)}</pre> */}
      <EmailParticipantsModal
        show={emailModal}
        onHide={() => setEmailModal(false)}
        intl={intl}
        selectedParticipants={selectedParticipants}
        event_slug={event.slug} //Diljith krishna - 2026-01-29 - Added to send event slug to backend
      />
    </div>
  </React.Fragment>;
}

export default ParticipantsListModal;